import { Vehiculos } from './../../../_entities/vehiculos';
import { Telefono } from './../../../_entities/telefonos/telefono';
import { Micromedidor } from './../../../_entities/micromedidores/micromedidor';
import { Medidores } from './../../../_entities/medidores/Medidores';
import { DispositivoVM } from './../../../_entities/dispositivos/DispositivoVM';
import { Activo } from './../../../_entities/activos/activo';
import { PermisoAgrupadoVM } from './../../../_entities/permisos/PermisoAgrupadoVM';
import { ClienteVM } from './../../../_entities/clientes/ClienteVM';
import { UsuarioVM } from './../../../_entities/usuarios/UsuarioVM';
import { environment } from './../../../../environments/environment';
import { UsuarioEdicionVM } from './../../../_entities/usuarios/UsuarioEdicionVM';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Producto } from './../../../_entities/productos/producto';
import { ProductosAsignados } from './../../../_entities/usuarios/productos-asignados';
import { Terminal } from './../../../_entities/terminal/terminal';
import { PanelCiudadano } from '../../../_entities/panelCiudadano/panelCiudadano';

@Injectable({
	providedIn: 'root'
})
export class UsuarioService {

	constructor(private http: HttpClient) { }

	getUsuario(id: string): Observable<UsuarioEdicionVM> {
		return this.http.get<UsuarioEdicionVM>(`${environment.API_SECURITY}/api/controlusuarios/${id}`);
	}

	getUsuarios(): Observable<UsuarioVM[]> {
		return this.http.get<UsuarioVM[]>(`${environment.API_SECURITY}/api/controlusuarios`);
	}

	getClientes(incluirClientePropietario: boolean = false): Observable<ClienteVM[]> {
		return this.http.get<ClienteVM[]>(`${environment.API_SECURITY}/api/Reportes/ClientesReportes`);
	}

	getPermisosAgrupados(): Observable<PermisoAgrupadoVM[]> {
		return this.http.get<PermisoAgrupadoVM[]>(`${environment.API_SECURITY}/api/permisos/agrupar/modulo`);
	}

	updateUsuario(id: string, form): Observable<any> {
		return this.http.put<any>(`${environment.API_SECURITY}/api/controlusuarios/${id}`, form);
	}

	deleteUsuario(id): Observable<any> {
		return this.http.delete<any>(`${environment.API_SECURITY}/api/controlusuarios/${id}`);
	}

	getActivos(): Observable<Activo[]> {
		return this.http.get<Activo[]>(environment.API_SECURITY + '/api/CrudActivos');
	}

	getPortatiless(): Observable<Activo[]> {
		return this.http.get<Activo[]>(environment.API_SECURITY + '/api/Portatiles');
	}

	getDispositivos(): Observable<DispositivoVM[]> {
		return this.http.get<DispositivoVM[]>(`${environment.API_SECURITY}/api/dispositivos`);
	}

	getMedidores(): Observable<Medidores[]> {
		return this.http.get<Medidores[]>(environment.API_SECURITY + '/api/Medidores')
	}
	getPanelCiudadano(): Observable<PanelCiudadano[]> {
		return this.http.get<PanelCiudadano[]>(environment.API_SECURITY + '/api/PanelCiudadano')
	}

	getMicromedidores(): Observable<Micromedidor[]> {
		return this.http.get<Micromedidor[]>(environment.API_SECURITY + '/api/Micromedidores');
	}


	getTelefonos(): Observable<Telefono[]> {
		return this.http.get<Telefono[]>(environment.API_SECURITY + '/api/Telefonos');
	}

	getTerminales(): Observable<Terminal[]> {
		return this.http.get<Terminal[]>(`${environment.API_SECURITY}/api/HandheldUHF`);
	}


	getVehiculos(): Observable<Vehiculos[]> {
		return this.http.get<Vehiculos[]>(environment.API_SECURITY + '/api/vehiculos')
	}

	getProductos(): Observable<Producto[]> {
		return this.http.get<Producto[]>(environment.API_SECURITY + '/api/Productos');
	}

	asignarVehiculos(vehiculos) {
		return this.http.post(environment.API_SECURITY + '/api/UsuariosVehiculos', vehiculos, { responseType: 'text' });
	}

	asignarActivos(activos) {
		return this.http.post(environment.API_SECURITY + '/api/CrudActivos/AsignarActivo', activos, { responseType: 'text' })
	}

	asignarPortatil(portatiles) {
		return this.http.post(environment.API_SECURITY + '/api/CrudActivos/AsignarPortatil', portatiles, { responseType: 'text' })
	}

	asignarPanelCiudadano(panel) {
		return this.http.post(environment.API_SECURITY + '/api/PanelCiudadano/AsignarPanel', panel, { responseType: 'text' })
	}


	asignarTelefonos(telefonos) {
		return this.http.post(environment.API_SECURITY + '/api/Telefonos/AsignarTelefono', telefonos, { responseType: 'text' });
	}

	asignarTermianlesUHF(terminales) {
		return this.http.post(environment.API_SECURITY + '/api/HandheldUHF/AsignarTerminal', terminales, { responseType: 'text' });
	}

	asingarMedidores(medidores) {
		return this.http.post(environment.API_SECURITY + '/api/medidores/AsignarMedidor', medidores, { responseType: 'text' });
	}

	asignarMicromedidores(micromedidores) {
		return this.http.post(environment.API_SECURITY + '/api/Micromedidores/AsignarMicromedidor', micromedidores, { responseType: 'text' });

	}


	obtenerProductos(idUsuario, tipoProducto): Observable<ProductosAsignados[]> {
		return this.http.get<ProductosAsignados[]>(`${environment.API_SECURITY}/api/ControlUsuarios/ProductosAsignados/${idUsuario}/${tipoProducto}`);
	}


	desasignarProducto(idUsuario, idProducto) {
		return this.http.delete(`${environment.API_SECURITY}/api/ControlUsuarios/DesasignarProducto/${idUsuario}/${idProducto}`, { responseType: 'text' });
	}


}
